// extracted by mini-css-extract-plugin
export default {"h3":"Servicios_h3__kHVTW","div":"Servicios_div__LG798","img":"Servicios_img__HHahA","p":"Servicios_p__rkXMA","div2":"Servicios_div2__Fz0YW"};